import React from 'react';
import { CtaButton } from './CtaButton';
import { TopoLines } from './TopoLines';
import { ProductStack } from './ProductStack';
const chips = ['6 Volumes', '60 Ready-to-Run Meetings', '5 Bonuses', '300+ Pages', 'Ages 6–17'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Works alongside any organization’s program'];

// Puntos de patrulla (leyenda del producto)
const patrols = ['bg-patrol-mustard', 'bg-patrol-teal', 'bg-patrol-plum', 'bg-patrol-slate', 'bg-ember'];
export function Hero() {
  return <section className="topo-dark relative w-full overflow-hidden border-b-4 border-ember bg-forest-deep" data-id="element-118" data-mp="x8jndoipuui9">
      <TopoLines className="pointer-events-none absolute -right-24 -top-12 h-[360px] w-[360px] text-paper/[0.07] sm:h-[460px] sm:w-[460px]" data-id="element-119" data-mp="nc88qrvnlskn" />

      <div className="relative z-10 mx-auto max-w-6xl px-5 pb-14 pt-7 sm:pb-20 sm:pt-12" data-id="element-120" data-mp="3d2l95b1th306">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-121" data-mp="3825wymt9u1js">
          <div data-id="element-122" data-mp="3j7zhzqi0g6kd">
            <p className="eyebrow text-ember" data-id="element-123" data-mp="3j9kc5f0exnhp">
              For volunteer troop, pack &amp; youth-group leaders
            </p>
            <h1 className="mt-3 font-display text-[34px] leading-[1.06] text-paper sm:text-5xl md:text-6xl" data-id="element-124" data-mp="3o6u71a6kmrcx">
              Troop night is Thursday.{' '}
              <span className="text-ember" data-id="element-125" data-mp="3e8mtl1bhqrfo">It’s already planned.</span>
            </h1>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-paper/80 sm:text-lg" data-id="element-126" data-mp="30iawsp3yo4i7">
              Troop Night Ready gives you 60 complete meetings and outdoor
              skills sessions — knots, fire, navigation, first aid, nature
              nights — each on a 3-page card you read once and lead. Not another
              pile of activity ideas: the whole night, timed, with what to say,
              what to bring and a rain plan.{' '}
              <span className="font-semibold text-paper" data-id="element-127" data-mp="2hjyo14gyown5">
                Even if you’re not an outdoors expert and only have 10 minutes
                to prep.
              </span>
            </p>
            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-128" data-mp="s3cki77jpdoz">
              {chips.map(chip => <li key={chip} className="rounded-md border border-paper/25 bg-paper/10 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-paper/90" data-id="element-129" data-mp="n9qf903poc37">
                  {chip}
                </li>)}
            </ul>
          </div>

          <ProductStack data-id="element-130" data-mp="1b04a0ydokp1h" />
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-131" data-mp="161axp9a4r42w">
          <div className="w-full max-w-md" data-id="element-132" data-mp="15zq2rijwlj4i">
            <CtaButton data-id="element-133" data-mp="1126ncfbgz0az">Get Troop Night Ready</CtaButton>
          </div>

          <div className="mt-5 flex max-w-md flex-col items-center gap-2.5 text-center sm:flex-row sm:text-left" data-id="element-134" data-mp="114kg2hiog0fd">
            <ul className="flex -space-x-1.5" aria-hidden="true" data-id="element-135" data-mp="3lsp3hdsd4jef">
              {patrols.map(color => <li key={color} className={`h-7 w-7 rounded-full border-2 border-forest-deep ${color}`} data-id="element-136" data-mp="3hqu0m4us9xyj" />)}
            </ul>
            <p className="text-[13px] leading-snug text-paper/70" data-id="element-137" data-mp="21amuh5blvkk8">
              Built for the parents, leaders and camp counselors who run a
              group every week — in the US, UK, Canada and Australia.
            </p>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-paper/65" data-id="element-138" data-mp="2b2ahmu14qffw">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-139" data-mp="2kyvntiovxwlb">
                <span className="h-1.5 w-1.5 rounded-full bg-ember" data-id="element-140" data-mp="2kxc9vyqpbxmp" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}